/**
 * FOC-20 · Botón flotante de WhatsApp.
 * En la ficha de producto mide la barra de compra fija de Horizon y expone su altura como
 * --foc-sticky-bar-height en el botón, para que en mobile suba justo por encima de la barra.
 * Sin JS, el CSS usa 120px como estimación. Sin dependencias.
 */
(function () {
  'use strict';

  function init() {
    var button = document.querySelector('.foc-whatsapp');
    var bar = document.querySelector('.sticky-add-to-cart__bar');
    if (!button || !bar) return;

    function update() {
      // offsetHeight es 0 cuando la barra está en display: none.
      button.style.setProperty('--foc-sticky-bar-height', bar.offsetHeight + 'px');
    }

    update();

    if ('ResizeObserver' in window) {
      new ResizeObserver(update).observe(bar);
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
